import {MsAuth} from '@/utils'
/**
 * 'Auth.service'
 * @version 1.0.0
 * @author Fernando Torres
 * @copyright Marciano Studio S.C., 2018
 */
const auth = new MsAuth(process.env.API_URL + 'login', 'Home')
export default auth



// WEBPACK FOOTER //
// ./src/services/auth.service.js